// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodProjectStatusEnum } from './FoodProjectStatusEnum';
import { foodProjectThemeEnum } from './FoodProjectThemeEnum';
import { operatorId } from './Operator';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const foodProjectId = (z.number());
export const foodProject = z.object({
    id: foodProjectId,
    name: z.string(),
    description: z.string().nullable(),
    status: foodProjectStatusEnum,
    theme: foodProjectThemeEnum,
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    assigned_to: operatorId,
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    tasting_brief: z.string().nullable(),
    tasting_photo_file_id: fileStorageId.nullable(),
    tasting_image_recipe: z.unknown().nullable(),
});
export const foodProjectInitializer = z.object({
    id: foodProjectId.optional(),
    name: z.string(),
    description: z.string().optional().nullable(),
    status: foodProjectStatusEnum.optional(),
    theme: foodProjectThemeEnum.optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    assigned_to: operatorId,
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    tasting_brief: z.string().optional().nullable(),
    tasting_photo_file_id: fileStorageId.optional().nullable(),
    tasting_image_recipe: z.unknown().optional().nullable(),
});
export const foodProjectMutator = z.object({
    id: foodProjectId.optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    status: foodProjectStatusEnum.optional(),
    theme: foodProjectThemeEnum.optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    assigned_to: operatorId.optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    tasting_brief: z.string().optional().nullable(),
    tasting_photo_file_id: fileStorageId.optional().nullable(),
    tasting_image_recipe: z.unknown().optional().nullable(),
});
//# sourceMappingURL=FoodProject.js.map